import { render, staticRenderFns } from "./LocalSvgIcon.vue?vue&type=template&id=63c01b7c&scoped=true"
import script from "./LocalSvgIcon.vue?vue&type=script&lang=js"
export * from "./LocalSvgIcon.vue?vue&type=script&lang=js"
import style0 from "./LocalSvgIcon.vue?vue&type=style&index=0&id=63c01b7c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c01b7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins_home/workspace/joinmc-html-develop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63c01b7c')) {
      api.createRecord('63c01b7c', component.options)
    } else {
      api.reload('63c01b7c', component.options)
    }
    module.hot.accept("./LocalSvgIcon.vue?vue&type=template&id=63c01b7c&scoped=true", function () {
      api.rerender('63c01b7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LocalSvgIcon.vue"
export default component.exports